import * as React from 'react';
import * as Redux from 'react-redux';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';

import { IReduxStore } from '../../types/redux';
import { HomeContainer } from '../HomeContainer';
import { ApplicationContext } from '../../utils/applicationContext';
import { IApplicationContext } from '../../types/application';

import * as styles from './app.css';
import { getProfiVacancies } from '../../actions/vacancies';
import { UiKitRoot } from '@cian/ui-kit';
import { CPDModalContainer } from '../CPDModal';

export interface IAppProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const App: React.FC<IAppProps> = ({ context, reduxStore: store }) => {
  React.useEffect(() => {
    store.dispatch(getProfiVacancies());
  }, [store]);

  return (
    <ApplicationContext.Provider value={context}>
      <Redux.Provider store={store}>
        <MicrofrontendProvider registry={context.microfrontendsRegistry}>
          <UiKitRoot>
            {/* TODO убрать стили из контейнера */}
            <section className={styles['mainpage']}>
              <HomeContainer />
              <CPDModalContainer />
            </section>
          </UiKitRoot>
        </MicrofrontendProvider>
      </Redux.Provider>
    </ApplicationContext.Provider>
  );
};
